import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
  BokkzAlgDataService, BokkzUitstelDataService, BokkzUitstelLogic,
  UitstelGegevens, UitstelGegevensBelastingmiddel, UitstelGegevensSoortUitstelVerzoek
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup} from "@angular/forms";
import {ToastService} from "@snelstart/ui-toast";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiButtonModule} from "@snelstart/ui-button";

@Component({
  selector: 'snelstart-venture-fiscaal-uitstel',
  standalone: true,
  imports: [CommonModule, SharedUiDetailsModule, SharedUiFormControlsModule, SharedUiButtonModule],
  templateUrl: './uitstel.component.html',
  styleUrl: './uitstel.component.scss',
})
export class UitstelComponent implements OnChanges {

  @Input() public id!: string;
  protected readonly UitstelGegevensBelastingmiddel = UitstelGegevensBelastingmiddel;
  public clientId: any;
  public uitstelGegevens = <UitstelGegevens>{};
  public formGroup = <FormGroup>{};
  public formGroupStatus = <FormGroup>{};
  public optionsUitstelType: SelectFormControlItem<string>[] = [
    {
      label: "Beconuitstel",
      value: "UITSTELVERZOEK_BECONREGELING",
      disabled: false
    },
    {
      label: "Verzoek bijzonder uitstel",
      value: "VERZOEK_BIJZONDER_UITSTEL",
      disabled: false
    },
    {
      label: "Verzoek incidenteel uitstel",
      value: "VERZOEK_INCIDENTEEL_UITSTEL",
      disabled: false
    },
    {
      label: "Verzoek individueel uitstel",
      value: "VERZOEK_INDIVIDUEEL_UITSTEL",
      disabled: false
    },
    {
      label: "Verzoek aanvullend uitstel",
      value: "AANVULLEND_UITSTEL",
      disabled: false
    },
    {
      label: "Afmelden",
      value: "AFMELDEN_UITSTEL",
      disabled: false
    },
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzUitstelDataService,
    public bokkzClient: BokkzUitstelLogic,
    public toastService: ToastService,
    public fb: FormBuilder,
  ) {
    this.formGroup = this.fb.group({
      soortUitstelVerzoek: null as unknown as UitstelGegevensSoortUitstelVerzoek,
      motivatieBijzonderUitstel: null as unknown as string,
      belastingmiddel: null as unknown as UitstelGegevensBelastingmiddel,
      fiscaalNummer: null as unknown as string,
      voorlettersBelastingplichtige: null as unknown as string,
      tussenVoegselBelastingplichtige: null as unknown as string,
      achternaamBelastingplichtige: null as unknown as string,
      boekjaarStart: null as unknown as Date,
      boekjaarEind: null as unknown as Date,
      datumAanvraag: null as unknown as Date,
      datumToegekend: null as unknown as Date,
      datumUitstelTot: null as unknown as Date,
      datumIngeleverd: null as unknown as Date,
      omschrijving: null as unknown as string,
    })
    this.formGroupStatus = this.fb.group({
      status: null as unknown as string,
    })
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const idChanges = changes['id'];
    if (idChanges && idChanges.currentValue !== idChanges.previousValue) {
      this.algDataService.client.subscribe((value) => {
        this.clientId = value.id;
      })
      this.dataService.uitstelGegevensList.subscribe((value) => {
          const item = value.find(x => x.fiscaalNummer! === this.id)
          if (item) {
            this.formGroup.reset()
            this.uitstelGegevens = item;
            this.formGroup.patchValue(item);
          }
        }
      );
    }
  }

  public saveForm() {
    setTimeout(() => {
      this.uitstelGegevens = {
        ...this.uitstelGegevens,
        boekjaarStart: this.formGroup.value.boekjaarStart,
        boekjaarEind: this.formGroup.value.boekjaarEind,
        motivatieBijzonderUitstel: this.formGroup.value.motivatieBijzonderUitstel
      }
      this.dataService.updateGegevens(this.uitstelGegevens);
    }, 0)
  }
}
